import React from 'react';

const CommonContext = React.createContext<any>({ common: {} });

export { CommonContext };
